export const messages = {
  en: {
    addItemOut: {
      recipient: 'Recipient',
      return: 'Return',
      warehouse: 'Warehouse',
      warehousePlaceholder: 'Required, please select a warehouse',
      contactPlaceholder: 'Required, please enter contact name',
      phonePlaceholder: 'Required, please enter contact phone',
      notePlaceholder: 'Required, please enter application note',
      itemInfo: 'Item Information',
      selectItem: 'Select Item',
      itemType: 'Item Type',
      itemName: 'Item Name (Code)',
      itemSpec: 'Item Specification',
      price: 'Price',
      stock: 'Stock',
      applyQuantity: 'Apply Quantity',
      remark: 'Remark',
      operation: 'Operation',
      selectPrice: 'Please select price',
      quantityPlaceholder: 'Required, please enter quantity',
      remarkPlaceholder: 'Optional, please enter remark',
      remove: 'Remove',
      approver: 'Approver',
      approverPlaceholder: 'Required, please select approver',
      select: 'Select',
      submit: 'Submit',
      warehouseRequired: 'Please select a warehouse',
      contactRequired: 'Please enter contact name',
      phoneRequired: 'Please enter contact phone',
      noteRequired: 'Please enter application note',
      itemRequired: 'Please select at least one item',
      sameWarehouseRequired: 'Items must be from the same warehouse',
      insufficientStock: 'Insufficient stock',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Submission failed',
      submitError: 'Error occurred during submission',
      selectRecipient: 'Select Recipient',
      contactPhone: 'Contact Phone',
      applicationNote: 'Application Note'
    },
    
  },
  zh: {
    addItemOut: {
      recipient: '领用人',
      return: '返回',
      warehouse: '仓库',
      warehousePlaceholder: '必填，请选择仓库',
      contactPlaceholder: '必填，请填写联系人',
      phonePlaceholder: '必填，请填写联系电话',
      notePlaceholder: '必填，请填写申请说明',
      itemInfo: '物品信息',
      selectItem: '选择物品',
      itemType: '物品类型',
      itemName: '物品名称(编码)',
      itemSpec: '物品规格',
      price: '价格',
      stock: '物品库存',
      applyQuantity: '申请数量',
      remark: '备注',
      operation: '操作',
      selectPrice: '请选择价格',
      quantityPlaceholder: '必填，请填写申请数量',
      remarkPlaceholder: '选填，请填写备注',
      remove: '移除',
      approver: '审批人',
      approverPlaceholder: '必填，请选择审批人',
      select: '选择',
      submit: '提交',
      warehouseRequired: '请选择仓库',
      contactRequired: '请填写联系人',
      phoneRequired: '请填写联系电话',
      noteRequired: '请填写申请说明',
      itemRequired: '请至少选择一个物品',
      sameWarehouseRequired: '领用商品需来自同一仓库',
      insufficientStock: '库存不够',
      submitSuccess: '操作成功',
      submitFailed: '操作失败',
      submitError: '提交过程中发生错误',
      selectRecipient: '选择领用人',
      contactPhone: '联系电话',
      applicationNote: '申请说明'
    },
    
  }
}